var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"counter"},[_c('v-uni-view',{staticClass:"counter-inner"},[_vm._v(" "+_vm._s(_vm.$t("artical.当前已有"))+" "),_vm._l((_vm.counterNum),function(item,idx){return _c('v-uni-view',{key:idx,staticClass:"counter-num"},[_vm._v(_vm._s(item))])}),_vm._v(" "+_vm._s(_vm.$t("artical.次阅读"))+" ")],2)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }